import { useState, useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import LandingPage from './components/LandingPage/LandingPage';
import RoomScenePage from './components/RoomscenePage/RoomscenePage';
import VisualizerPage from './components/VisualizerPage/VisualizerPage';

import LoadingPage from './components/LoadingPage/LoadingPage';
import ChamUpload from './components/ChamUpload/ChamUpload';
import ChamProjects from './components/ChamProjects/ChamProjects';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';

import { visualizerActions, uiActions } from './store';
import { getAllSheetsFromFile } from './Helpers/SheetsHelper';
import { jsonHelper } from './Helpers/JsonHelper';

const router = createBrowserRouter([
  { path: '/', element: <><RoomScenePage /> <ChamProjects /></>, errorElement: <><h1>ERROR</h1></> },
  { path: '/shared/:code/*', element: <LoadingPage/> },
  { path: '/roomscenes', element: <><RoomScenePage />  <ChamProjects /></>  },
  { path: '/visualizer/spec/:specifier/sel/:selString', element: <><VisualizerPage /> <ChamProjects /></>  },
]);

function App() {
  const popUpModalActive = useSelector((state) => state.ui.popUpModalActive);
  const masterData = useSelector(s => s.visualizer.productDataBySeries) || {};
  const [dataReady, setDataReady] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        dispatch(uiActions.setVizLoading(true));

        const [
          flooringSheets,
          manningtonCarpet,
          manningtonLvt,
          manningtonBroadloom,
          heterogeneoussheet,
          homogeneoussheet,
          installMethods,
          wallColors,
        ] = await Promise.all([
          getAllSheetsFromFile("/data/flooringData.xlsx"),
          jsonHelper("8639"),
          jsonHelper("8645"),
          jsonHelper("8347"),
          jsonHelper("8644"),
          jsonHelper("8643"),
          jsonHelper("8642"),
          jsonHelper("7973"),
        ]);

        if (cancelled) return;

        const byId = (arr) =>
          arr.reduce((acc, obj) => {
            acc[obj.id] = obj;
            return acc;
          }, {});

        dispatch(
          visualizerActions.setProductDataBySeries({
            seriesId: 8639,
            data: byId(manningtonCarpet),
          })
        );
        dispatch(
          visualizerActions.setProductDataBySeries({
            seriesId: 8645,
            data: byId(manningtonLvt),
          })
        );
        dispatch(
          visualizerActions.setProductDataBySeries({
            seriesId: 8347,
            data: byId(manningtonBroadloom),
          })
        );
        dispatch(
          visualizerActions.setProductDataBySeries({
            seriesId: 8644,
            data: byId(heterogeneoussheet),
          })
        );
        dispatch(
          visualizerActions.setProductDataBySeries({
            seriesId: 8643,
            data: byId(homogeneoussheet),
          })
        );
        dispatch(
          visualizerActions.setProductDataBySeries({
            seriesId: 7973,
            data: byId(wallColors),
          })
        );

        const installByName = installMethods.reduce((acc, obj) => {
          acc[obj.name] = obj;
          return acc;
        }, {});
        dispatch(
          visualizerActions.setProductDataBySeries({
            seriesId: 8642,
            data: installByName,
          })
        );

        setDataReady(true);
      } catch (err) {
        console.error("Data bootstrap failed:", err);
        setDataReady(false);
      } finally {
        if (!cancelled) {
          dispatch(uiActions.setVizLoading(false));
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  // detect ?style_code after data is ready
  useEffect(() => {
    if (!dataReady) return;

    const params = new URLSearchParams(window.location.search);

    if (params.has("style_code")) {
      const styleCode = params.get("style_code"); 

      console.log("style_code param found:", styleCode);

      // TODO: your processing here, e.g.:
      // dispatch(visualizerActions.setActiveStyleCode(styleCode));
      // or navigate somewhere, etc.
      const search = window.location.search || "";
      const hash = window.location.hash || "";

      const url =
        `/visualizer/spec/Mannington%5CImages%5CStandard%5CEducation_Classroom_9/sel/-1` +
        search +
        hash;

      // 👈 navigate using the router instance, not the hook
      router.navigate(url);

      dispatch(visualizerActions.setActiveProductMenuTab("flooring"));
      dispatch(visualizerActions.setActiveFlooringSubMenuTab("Modular Carpet"));
      dispatch(visualizerActions.setActiveFlooringSeriesIds([8639]));

      
      let product = masterData[8639][5967217];
      console.log(product)

      dispatch(visualizerActions.setAppliedProduct({
            location: 'chamViz',
            surface: 'Floor',
            data: {
                colorway: product,
                selStrings: [],
                size: null,
                install: 5983716,
            },
        }));

    }
  }, [dataReady, dispatch]);

  return (
    <div className={`App ${popUpModalActive ? "blur" : ""}`}>
      {dataReady ? (
        <>
          <RouterProvider router={router} />
          <ChamUpload />
        </>
      ) : (
        <LoadingScreen />
      )}
    </div>
  );
}

export default App;
